import axios from 'axios';

import { axiosHeaderV2, getV2RootUrl } from 'common/helpers/apiHelper';

export const getLoyaltyPointsAvailability = (cartId) =>
  axios.get(
    `${getV2RootUrl()}/cart/${cartId}/loyalty-point-availability`,
    axiosHeaderV2()
  );
